import React from 'react';
import { TableHead } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { TableRow, TableCell } from '@mui/material';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles((theme) => ({
  tableRow: {
    '& >th': {
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(0.5),
      paddingLeft: theme.spacing(0),
      color: theme.palette.grey[700],
      fontWeight: 400,
      background: theme.palette.information.pageBackground
    },
    '& > th:nth-child(1)': {
      minWidth: theme.spacing(30),
      width: '39%'
    },
    '& > th:nth-child(2)': {
      minWidth: theme.spacing(15),
      width: '16%'
    },
    '& > th:nth-child(3)': {
      minWidth: theme.spacing(12),
      width: '9%'
    },
    '& > th:nth-child(4)': {
      minWidth: theme.spacing(15),
      width: '13%'
    },
    '& > th:nth-child(5)': {
      minWidth: theme.spacing(15),
      width: '12%'
    },
    '& > th:last-child': {
      minWidth: theme.spacing(20),
      width: '11%'
    }
  }
}));
export const InstalledCollectorHeader: React.FC = () => {
  const classes = useStyles();
  return (
    <TableHead>
      <TableRow
        data-testid={'installed-collector-header'}
        className={classes.tableRow}
      >
        <TableCell>
          <FormattedMessage id={'installedCollectors.collectorName'} />
        </TableCell>
        <TableCell>
          <FormattedMessage id={'installedCollectors.type'} />
        </TableCell>
        <TableCell>
          <FormattedMessage id={'installedCollectors.installedBy'} />
        </TableCell>
        <TableCell>
          <FormattedMessage id={'installedCollectors.date'} />
        </TableCell>
        <TableCell>
          <FormattedMessage id={'installedCollectors.status'} />
        </TableCell>
        <TableCell>
          <FormattedMessage id={'installedCollectors.action'} />
        </TableCell>
      </TableRow>
    </TableHead>
  );
};
export default React.memo(InstalledCollectorHeader);
